// extracted by mini-css-extract-plugin
export default {"chevronVertical":"zuE9EJN2","chevronVerticalRotated":"dPPUYs8M"};